import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes me tomaba casi 3 horas armar un informe después de cada sesión. Ahora lo hago en la mitad del tiempo y mis consultantes me dicen que se ven mucho más profesionales. No puedo creer que no lo haya encontrado antes.',
  name: 'Laura Martínez',
  role: 'Facilitadora de Registros Akáshicos · Buenos Aires, 36 años'
}, {
  quote: 'Estaba agotada de trabajar tanto y ganar lo mismo. Con el sistema pude subir mis precios porque ahora mis entregas tienen otro nivel. Mis consultantes notan la diferencia y me recomiendan más.',
  name: 'Daniela Sosa',
  role: 'Facilitadora · Córdoba, 40 años'
}, {
  quote: 'Lo que más me gustó es que no perdí mi esencia. Las lecturas siguen siendo mías, pero ahora están organizadas y se ven increíbles. Recuperé tiempo para mí y para seguir formándome.',
  name: 'Camila Reyes',
  role: 'Facilitadora · Mendoza, 33 años'
}, {
  quote: 'Tenía miedo de que fuera algo muy técnico o difícil de usar. Pero es súper intuitivo. En una semana ya estaba entregando informes con el nuevo formato y mis consultantes quedaron encantadas.',
  name: 'Florencia Giménez',
  role: 'Facilitadora · Rosario, 28 años'
}, {
  quote: 'Llevo años dando lecturas y nunca había encontrado algo así. Me ayudó a profesionalizar mi trabajo sin perder la calidez que mis consultantes valoran. Ahora puedo atender más sin sentirme abrumada.',
  name: 'Patricia Villalba',
  role: 'Facilitadora · Mar del Plata, 49 años'
}];
function StarRating() {
  return <div className="flex gap-1 mb-4" data-id="element-215">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-216" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-12 md:py-24 px-4 bg-mystic-800 relative" data-id="element-217">
      <div className="max-w-7xl mx-auto" data-id="element-218">
        <div className="text-center mb-8 md:mb-16" data-id="element-219">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-5xl font-serif font-bold mb-3 md:mb-4 text-white" data-id="element-220">
            Lo que dicen las facilitadoras
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-xl text-gold-light italic font-serif" data-id="element-221">
            Profesionales que ya transformaron su práctica
          </motion.p>
        </div>

        {/* Masonry-like layout for testimonials */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-6 space-y-4 md:space-y-6" data-id="element-222">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="break-inside-avoid glass-card p-5 md:p-8 rounded-2xl" data-id="element-223">
              <StarRating data-id="element-224" />
              <p className="text-sm md:text-base text-gray-300 italic mb-4 md:mb-6 leading-relaxed" data-id="element-225">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-mystic-700 pt-3 md:pt-4" data-id="element-226">
                <p className="font-bold text-sm md:text-base text-white" data-id="element-227">
                  {testimonial.name}
                </p>
                <p className="text-xs md:text-sm text-gray-400 mt-1" data-id="element-228">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}